import { render, staticRenderFns } from "./WapFields.vue?vue&type=template&id=3cb1302e&scoped=true&"
import script from "./WapFields.vue?vue&type=script&lang=js&"
export * from "./WapFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb1302e",
  null
  
)

export default component.exports